<template>
  <div>
    <div class="login-form">
      <div class="app_logo">
        <img src="@/assets/icons/app_logo.png" width="70%" alt="AppLogo">
      </div>
      <div class="error-block" v-if="formError">
        <span>{{ formError }}</span>
      </div>
      <form @submit.prevent="submitForm" autocomplete="off" class="form">
        <div class="input-box">
          <div class="title">{{ $t("Login") }}</div>
          <!-- Email Field -->
          <div class="form-group" :class="{ focused: emailFocused || email }">
            <label>{{ $t("Email") }}</label>
            <input type="text" v-model="email" @focus="emailFocused = true" @blur="emailFocused = false"
              @input="() => { if (emailError) emailError = null }" autocomplete="off" />
            <div class="input-error" v-if="emailError">{{ emailError }}</div>
          </div>

          <!-- Password Field -->
          <div class="form-group" :class="{ focused: passwordFocused || password }">
            <label>{{ $t("Confirm Password") }}</label>
            <input :type="showPassword ? 'text' : 'password'" v-model="password" @focus="passwordFocused = true"
              @input="() => { if (passwordError) passwordError = null }" @blur="passwordFocused = false"
              autocomplete="off" />
            <span class="toggle-eye" @click="togglePassword">
              <img style="width: 30px;" :src="eyeopen" alt />
            </span>
            <div class="input-error" v-if="passwordError">{{ passwordError }}</div>
          </div>
        </div>

        <div class="lookup-form-container-continue-button">
          <button class="button-primary" id="lookupbutton" type="submit" :disabled="loader">
            <Loading class="loader" v-if="loader" :size="'16px'"></Loading>
            <div class="continue-svg" v-else>
              <span>{{ $t("continue") }}</span>
              <span class="arrow-wrapper">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                  class="arrow feather feather-arrow-right">
                  <line x1="5" y1="12" x2="19" y2="12"></line>
                  <polyline points="12 5 19 12 12 19"></polyline>
                </svg>
              </span>
            </div>
          </button>
        </div>
        <div class="forgot_password">
          <p>
            <span> {{ $t("Forgot your password") }} </span> <span class="recover" @click="redirectToMicuenta">| {{
              $t("Recover it here") }} </span>
          </p>
        </div>
      </form>
    </div>
    <div class="register-popup blurred" v-if="registerPopupShow">
      <div class="register-popup-content">
        <div class="register-popup-header">
          <div class="register-popup-title">
            {{ $t("Activate your access!") }}
          </div>
        </div>
        <div class="register-popup-body">
          <div class="register-popup-text">
            {{ $t("Register line one") }}
          </div>
          <div class="register-popup-text">
            {{ $t("Register line two") }}
          </div>
        </div>
        <div class="register-popup-footer">
          <button class="button-primary" @click="closebtn">
            {{ $t("Close") }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { eventBus } from "@/eventBus";
import Utility from "@/mixins/Utility.js";
import { mapActions, mapMutations, mapGetters } from "vuex";
import googleAnalytics from "@/mixins/googleAnalytics.js";
import cleverTap from "@/mixins/clevertap.js";

import { _providerId } from "@/provider-config.js";

import FirebaseActions from "@/mixins/FirebaseActions.js";

export default {
  data() {
    return {
      email: '',
      password: '',
      emailFocused: false,
      passwordFocused: false,
      showPassword: false,
      eyeopen: require("@/assets/icons/eye.svg"),
      eyeClose: require("@/assets/icons/eye-close.svg"),
      eyeOpen: require("@/assets/icons/eye.svg"),
      loader: false,
      inputtype: "Email",
      formError: null,
      emailError: null,
      passwordError: null,
      registerPopupShow: false
    };
  },
  methods: {
    ...mapMutations(["setUserInfo", "setToken", "setProfileid"]),
    ...mapActions(["actGetLogin", "actGetSubscriber", "getCaptcha", "login", "listProfiles", "parentalControlStatus"]),

    togglePassword() {
      this.showPassword = !this.showPassword;
      this.eyeopen = this.showPassword ? this.eyeClose : this.eyeOpen;
    },

    redirectToMicuenta() {
      window.open(`${this.appConfig.urls.externalbased.forgotPasswordUrl}`, "_blank");
    },

    submitForm() {
      // handle login
      this.emailError = null;
      this.passwordError = null;
      this.formError = null;

      let valid = true;

      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

      if (!this.email.trim()) {
        this.emailError = this.$t("Email is required");
        valid = false;
      } else if (!emailRegex.test(this.email.trim())) {
        this.emailError = this.$t("Please enter a valid email");
        valid = false;
      }

      if (!this.password.trim()) {
        this.passwordError = this.$t("Password is required");
        valid = false;
      } else if (this.password.trim().length < 4) {
        this.passwordError = this.$t("Password must be at least 4 characters");
        valid = false;
      }

      if (!valid) return;

      this.loader = true;
      let userCountry = JSON.parse(localStorage.getItem("currentUserCountry"));
      let payload = {
        app: "SELF",
        params: {
          email: this.email.trim(),
          password: this.password.trim(),
          devicetype: "PC",
          deviceos: this.getDeviceOS(),
          country: this.country?.CountryCode || userCountry.CountryCode,
        },
      };

      eventBus.$emit("subscriberExternalLogin", payload);
    },

    closebtn() {
      this.registerPopupShow = false;
    },

    checkMobileWeb() {
      let isMobile = RegExp(/Android|webOS|iPhone|iPod|iPad|BlackBerry|IEMobile|Opera Mini/i).test(navigator.userAgent);

      if (!isMobile) {
        const isMac = RegExp(/Macintosh/i).test(navigator.userAgent);

        if (isMac && navigator.maxTouchPoints && navigator.maxTouchPoints > 2) {
          isMobile = true;
        }
      }
      if (isMobile && localStorage.getItem("isMobile") == "true") {
        let payload = {
          state: true,
          message: "Login successfull",
          color: "green",
        };
        eventBus.$emit("snackBarMessage", payload);
        eventBus.$emit("triggerInitView", payload);
 

        let currentLanguage = this.getCurrentLanguageUrlBase();
        this.$router.push({name: 'seeAllPlans', params: {lang: currentLanguage}});
      }
    },
  },
  components: {
    Loading: () => import(/* webpackChunkName: "Loading" */ "@/components/Templates/Loading.vue"),
  },
  computed: {
    ...mapGetters(["appConfig", "gettoken", "subscriberid", "getRtl", "country", "profileid", "subscriptionList"]),
  },
  created() {
    eventBus.$on("login-response", (response) => {
      let GA = {};
      this.loader = false;
      if (response.reason) {
        if (response.errorcode === 6110) {
          // this.resendLink = this.$t(response.reason);
          // this.resendText = this.resendText = this.inputtype === "Email" ? this.$t("Verify") : this.$t("Verify");
        } else if (response.errorcode === 7309 || response.reason === "The user does not exist on mvshub.") {
          this.registerPopupShow = true;
        } else {
          if (response.errorcode === 6005 || response.reason === "Invalid Otp") {
            this.formError = this.$t(response.reason);
            this.userPin = [];
            return;
          }
          this.formError = this.$t(response.reason);
          this.userPin = [];

          if (response.errorcode !== 7303) {
            this.isCaptchaEnabled = false;
            this.loginCaptcha = "";
            this.captchaImage = null;
            this.captchaReferenceId = null;
          }
        }

        //constructing google analytics details.
        GA.login_mode = this.inputtype === "Email" ? "Email" : "Mobile";
        GA.status = "Failed";
        GA.error_reason = response.reason;
      } else if (response.successtype === "CAPTCHA") {
        this.isCaptchaEnabled = true;
        this.captchaImage = response && response.success ? response.success.payload : "";
        this.captchaReferenceId = response && response.success ? response.success.referenceid : "";

      } else {
        //constructing google analytics details.
        GA.login_mode = this.inputtype === "Email" ? "Email" : "Mobile";
        GA.status = "Success";
        // let message = "Login Successfull"
        // this.snackbarMessage(message);
        localStorage.setItem("sessionToken", response.success);
        // eventBus.$emit("subscriberDetails");
        localStorage.setItem("isMultipleProfileEnabled", this.appConfig.featureEnabled.isMobileOtpLoginEnabled);
        if (this.appConfig.featureEnabled.isMultipleProfileEnabled) {
          let currentLanguage = this.getCurrentLanguageUrlBase();


          this.listProfiles().then((profileResponse) => {
            const totalCount = profileResponse?.data?.totalcount || 0;
            if (totalCount > 1) {
            
              this.parentalControlStatus()
                .then((data) => {
                  if (data.reason) {
                    return;
                  }
                  if (data?.data?.isenabled) {
                    localStorage.setItem("parentalControlEnabled", data.data.isenabled);
                  }
                });
              this.$router.push({
                name: "switchProfile",
                params: { lang: currentLanguage, renderCancel: false },
                query: { islogin: true },
              });
            } else {
              if (window.selectedPlanInfomationRouting && !(this.subscriptionList && this.subscriptionList.length > 0)) {
                this.$router.push({ name: "Home", params: { lang: currentLanguage } });
                setTimeout(() => {
                  eventBus.$emit("open-home-rzp-modal", window.selectedPlanInfomationRouting);
                  window.selectedPlanInfomationRouting = "";
                }, 500);
              } else {
                this.$router.push({
                  path: window.storeAfterLoginPath ? window.storeAfterLoginPath : currentLanguage ? `/${currentLanguage}` : '/',
                });
              }
              window.storeAfterLoginPath = "";
            }
          }).catch((error) => {
            console.error("Error fetching profiles:", error);
            this.$router.push({
              path: currentLanguage ? `/${currentLanguage}` : '/',
            });
            window.storeAfterLoginPath = "";
          });
        }

        const localappConfig = this.appConfig;
        let convertingMobileViewControllerToBoolean;

        if (localappConfig && localappConfig.mobileViewController) {
          convertingMobileViewControllerToBoolean = JSON.parse(this.appConfig.mobileViewController.toLowerCase());
        }

        if (convertingMobileViewControllerToBoolean) {
          this.checkMobileWeb();
        }
      }

      const browser = this.getPlatformType();

      GA.platform = this.getPlatform();

      GA.platform_type = browser.browser;

      
      //logging signup google analytics event.
      this.loginEvent(GA);
    });
    },
    mixins: [Utility, googleAnalytics, cleverTap, FirebaseActions],
  };
</script>

<style scoped lang="scss">
@import "@/sass/_variables.scss";
@import "@/sass/_components.scss";

.login-form {
  max-width: 400px;
  margin: 4rem auto;
  font-family: Arial, sans-serif;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;

  .app_logo {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

form {
  display: flex;
  flex-direction: column;
}

.input-box {
  margin: 2.5rem auto 1.5rem;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  align-items: center;
  justify-content: center;

  .title {
    font-family: 2rem;
    font-weight: 500;
  }

  .form-group {
    position: relative;
    width: 100%;

    .input-error {
      color: red;
      font-size: 12px;
      margin-top: 4px;
    }
  }
}

label {
  position: absolute;
  left: 0;
  top: 12px;
  color: #aaa;
  font-size: 16px;
  pointer-events: none;
  transition: all 0.2s ease;
}

input {
  width: 100%;
  padding: 12px 0 6px 0;
  border: none;
  border-bottom: 2px solid #ccc;
  font-size: 0.8rem;
  outline: none;
  background: transparent;
  box-shadow: none;
  appearance: none;
  border-top: none !important;
  border-left: none !important;
  border-right: none !important;
  caret-color: #dcdcdc;
}

input:focus {
  border-bottom-color: $primary-color;
}

.form-group.focused label {
  top: -10px;
  font-size: 1rem;
}

.toggle-eye {
  position: absolute;
  right: 0;
  bottom: 1rem;
  cursor: pointer;
  color: #666;
}

.forgot_password {
  margin: 3rem 0;
  display: flex;
  gap: 1.5rem;
  align-items: center;
  justify-content: center;

  .recover {
    color: chocolate;
    cursor: pointer;
  }
}

.button-primary {
  width: 50%;
  float: right;
  border-radius: 2rem;
  font-size: 0.8rem;
  position: relative;
  overflow: hidden;
  cursor: pointer;

  .continue-svg {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 1.2rem;
    transition: all 0.3s ease;

    .arrow-wrapper {
      display: inline-block;
      transition: transform 0.3s ease;
    }
  }
}

.button-primary:hover .arrow-wrapper {
  transform: translateX(50%);
}

input:-webkit-autofill {
  -webkit-box-shadow: 0 0 0px 1000px #000 inset !important;
  /* Dark background */
  -webkit-text-fill-color: #fff !important;
  /* White text */
  transition: background-color 9999s ease-in-out 0s;
}

.error-block {
  border: 0.1rem solid red;
  border-radius: 0.2rem;
  padding: 0.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 75%;
  margin: 1.5rem auto 0;

  span {
    width: 100%;
    word-wrap: break-word;
    overflow-wrap: break-word;
    color: red;
    text-align: center;
    text-overflow: ellipsis;
    height: auto;
  }
}

.register-popup {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #212121;
    //opacity: 0.9;
    z-index: 999999999;
    display: flex;
    align-items: center;
    justify-content: center;

    .register-popup-content {
        padding: 2rem;
        border: 1px solid #222222;
        background: #e1e1e1;
        max-width: 600px;
        width: 35%;
        min-width: 320px;
        color: #000000;
        border-radius: 0.5rem;

        .register-popup-header {
            text-align: center;
            .register-popup-title {
                font-size: 1.5rem;
                font-weight: bold;
            }
        }

        .register-popup-body {
            padding: 2rem 1rem;
            text-align: center;
            display: flex;
            flex-direction: column;
            gap: 1rem;
        }

        .register-popup-footer {
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 1rem;

            .register-popup-btns {
                border-radius: 8px;
                background-color: #999;
                padding: 1rem 2rem;
                font-weight: bold;
                font-size: clamp(0.5rem, 2vw, 1rem);
                text-align: center;
                cursor: pointer;

                &:hover {
                    transform: scale(1.05);
                }
            }

            .button-primary {
                max-width: 70%;
                font-size: 1rem;
                &:hover {
                    background-color: $primary-btn-color;
                    color: $clr-primary-button-common;
                }
            }
        }
    }
}

@media screen and (max-width: 687px) {
    .login-form {
        width: clamp(2rem, 100%, 75%);
        margin: 4rem auto 0;
    }
}

</style>
  
